module.exports = __webpack_public_path__ + "static/media/full-screen-image-3.bce6cf1d.jpg";